/**
 * GraphQL Queries and Mutations for Integrated Auto-Scheduling Demo
 *
 * DEMO-ONLY: Used by the integrated auto-scheduling demo scenarios.
 */

import { gql } from '@apollo/client';

// Re-export existing mutations already defined elsewhere so demo callers
// can import from a single module.
export { CREATE_PATIENT } from '~/components/patient/EditPatient';
export { SCHEDULE_VISIT_FROM_VISIT_REQUEST } from '~/views/command/index';
export {
  CREATE_EPISODE_MUTATION,
  UPDATE_EPISODE_MUTATION,
  GET_EPISODE_CARE_REQUIREMENTS_QUERY,
} from '~/queries/episode';

/**
 * Query patient visits for polling/verification
 */
export const GET_PATIENT_VISITS_DEMO = gql(`
  query GetPatientVisitsDemo($patientId: Int!)
  @permission(requires: useWebApp)
  {
    patientSingle(where: { id: { eq: $patientId } }) {
      id
      firstName
      lastName
      addressTimezone
      episodes(where: { active: { eq: true } }) {
        id
        active
      }
      visits {
        id
        startTime
        endTime
        eventStatus
        episodeId
        arrivalWindowStartTime
        arrivalWindowEndTime
        visitType {
          id
          name
        }
        visitResources {
          id
          provider {
            id
            firstName
            lastName
          }
        }
        visitServices {
          service {
            id
            name
          }
        }
      }
    }
  }
`);

/**
 * Cancel a visit (for demo scenarios)
 */
export const CANCEL_VISIT_MUTATION = gql(`
  mutation CancelVisitDemo($visitId: Int!, $visitCancellationReasonId: Int!)
  @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
    cancelVisit(
      visitId: $visitId
      visitCancellationReasonId: $visitCancellationReasonId
    ) {
      id
      eventStatus
    }
  }
`);

/**
 * Get demo patients with visit counts
 */
export const GET_DEMO_PATIENTS = gql(`
  query GetDemoPatients
  @permission(requires: useWebApp)
  {
    activePatients(offset: 0, limit: 1, orderBy: { id: { direction: asc, priority: 1 } }) {
      id
    }
  }
`);

/**
 * Import existing patient query that includes visits to avoid hash errors
 */
export { PATIENT_QUERY as GET_PATIENT_WITH_VISITS } from '~/views/patients/patientDetails';
